import URIS from 'constants/uris';
import http from 'services/http';

export function createPayout(params) {
  return http.post(URIS.PAYOUT, params);
}
